import React from "react";
import { useNavigate } from "react-router-dom";
import "./PolicyPages.css";

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="auth-header">
        <div className="brand" onClick={() => navigate("/")}>
          <img
            src="/images/customroam-logo.png"
            alt="Custom Roam"
            className="logo-img"
          />
          <span className="brand-text">CUSTOM ROAM</span>
        </div>

        <div className="back-home" onClick={() => navigate("/")}>
          Back to Home
        </div>
      </div>

      <div className="policy-container">
        <h1>Custom Roam Terms and Conditions</h1>

        <p>
          <strong>Effective Date:</strong> July 11, 2026
        </p>

        <p>
          <strong>Last Updated:</strong> July 11, 2026
        </p>

        <hr />

        <h2>1. Acceptance of Terms</h2>

        <p>Welcome to Custom Roam.</p>

        <p>
          These Terms and Conditions ("Terms") govern your access to and use of
          the Custom Roam website, mobile applications, and related services
          collectively referred to as the "Services."
        </p>

        <p>
          By accessing or using the Services, you agree to be bound by these
          Terms. If you do not agree to these Terms, you may not access or use
          the Services.
        </p>

        <hr />

        <h2>2. Eligibility</h2>

        <p>To use Custom Roam:</p>

        <ul>
          <li>
            You must be at least 13 years old or the minimum age required by
            applicable law in your jurisdiction.
          </li>
          <li>
            You must have the legal capacity to enter into a binding agreement.
          </li>
          <li>
            You must provide accurate and truthful information when creating
            and maintaining your account.
          </li>
          <li>
            If you use the Services on behalf of an organization, business, or
            other entity, you represent that you have authority to bind that
            entity to these Terms.
          </li>
        </ul>

        <hr />

        <h2>3. User Accounts</h2>

        <p>When creating an account:</p>

        <ul>
          <li>
            You are responsible for maintaining the confidentiality of your
            login credentials.
          </li>
          <li>
            You are responsible for all activities occurring under your
            account.
          </li>
          <li>
            You must promptly notify us of any unauthorized access or security
            breach.
          </li>
          <li>
            You may not create fake, misleading, impersonating, or fraudulent
            accounts.
          </li>
          <li>
            You may not create multiple accounts for abusive, deceptive, or
            prohibited purposes.
          </li>
        </ul>

        <p>
          Custom Roam reserves the right to refuse, restrict, suspend, disable,
          or terminate accounts that violate these Terms or pose risks to the
          platform or its users.
        </p>

        <hr />

        <h2>4. Our Services</h2>

        <p>
          Custom Roam provides travel-planning and social-sharing tools,
          including but not limited to:
        </p>

        <ul>
          <li>Travel itinerary generation</li>
          <li>Travel recommendations</li>
          <li>Attraction discovery</li>
          <li>Saved itineraries</li>
          <li>Shared itineraries</li>
          <li>Public profiles</li>
          <li>Roam Share posts</li>
          <li>Photos and videos</li>
          <li>Comments and replies</li>
          <li>Notifications</li>
          <li>Bucket Lists</li>
          <li>Other related features and services</li>
        </ul>

        <p>
          We may modify, suspend, discontinue, or remove any feature,
          functionality, or portion of the Services at any time without
          liability.
        </p>

        <hr />

        <h2>5. Usernames and Profiles</h2>

        <p>
          Users are responsible for the information they provide in their
          profiles.
        </p>

        <p>
          Custom Roam reserves the right to modify, restrict, reclaim, remove,
          or disable usernames, profile information, biographies, profile
          photos, or other profile content that:
        </p>

        <ul>
          <li>Violates these Terms</li>
          <li>Is misleading</li>
          <li>Is offensive</li>
          <li>Impersonates another person or entity</li>
          <li>Infringes intellectual property rights</li>
          <li>Is otherwise deemed inappropriate</li>
        </ul>

        <hr />

        <h2>6. User Content</h2>

        <p>
          Users may upload, submit, publish, or share content including:
        </p>

        <ul>
          <li>Photos</li>
          <li>Videos</li>
          <li>Captions</li>
          <li>Comments</li>
          <li>Replies</li>
          <li>Reviews</li>
          <li>Public itineraries</li>
          <li>Profile information</li>
          <li>Other content</li>
        </ul>

        <p>Users retain ownership of content they submit.</p>

        <p>
          By submitting content, you grant Custom Roam a worldwide,
          non-exclusive, royalty-free, transferable, and sublicensable license
          to host, store, display, reproduce, distribute, modify, publish, and
          promote that content for purposes related to operating, improving,
          promoting, and providing the Services.
        </p>

        <p>You represent that:</p>

        <ul>
          <li>You own the content or have permission to use it.</li>
          <li>The content does not violate any law.</li>
          <li>The content does not infringe the rights of others.</li>
          <li>You are solely responsible for your content.</li>
        </ul>

        <p>
          You acknowledge that your content may be reported by other users for
          review if it is believed to violate these Terms, applicable laws, or
          our community standards.
        </p>

        <hr />

        <h2>7. Public Content</h2>

        <p>Certain content may be publicly visible, including:</p>

        <ul>
          <li>Usernames</li>
          <li>Profile photos</li>
          <li>Public profiles</li>
          <li>Public itineraries</li>
          <li>Posts</li>
          <li>Comments</li>
          <li>Replies</li>
          <li>Other publicly shared content</li>
        </ul>

        <p>
          You acknowledge that publicly shared content may be viewed, copied,
          shared, indexed, archived, or redistributed by other users or third
          parties.
        </p>

        <p>
          Custom Roam cannot guarantee the removal of copies made by third
          parties.
        </p>

        <hr />

        <h2>8. Prohibited Conduct</h2>

        <p>You agree not to:</p>

        <ul>
          <li>Violate applicable laws</li>
          <li>Harass, threaten, or abuse others</li>
          <li>Post hateful, discriminatory, or harmful content</li>
          <li>Impersonate individuals or organizations</li>
          <li>Infringe intellectual property rights</li>
          <li>Upload malicious software or code</li>
          <li>Attempt unauthorized access to systems</li>
          <li>Scrape, crawl, or harvest data</li>
          <li>Use bots or automated tools without authorization</li>
          <li>Interfere with platform operations</li>
          <li>Circumvent security measures</li>
          <li>Create fake accounts</li>
          <li>Commit fraud or engage in deceptive practices</li>
          <li>Distribute spam or unwanted promotional content</li>
        </ul>

        <hr />

        <h2>9. Content Moderation and User Reports</h2>

        <p>Custom Roam may, at its sole discretion:</p>

        <ul>
          <li>Review content</li>
          <li>Investigate reports</li>
          <li>Restrict the visibility of content</li>
          <li>Remove content</li>
          <li>Disable access to content</li>
          <li>Issue warnings</li>
          <li>Restrict accounts</li>
          <li>Suspend accounts</li>
          <li>Permanently terminate accounts</li>
        </ul>

        <p>
          These actions may occur with or without prior notice, depending on the
          circumstances.
        </p>

        <p>
          Users may report other users, posts, comments, or other content that
          they believe violates these Terms, applicable laws, or our community
          standards.
        </p>

        <p>
          Custom Roam reviews reports at its sole discretion and may
          investigate, remove content, issue warnings, restrict accounts,
          suspend accounts, or permanently terminate accounts when appropriate.
        </p>

        <p>
          Submission of a report does not guarantee that any specific action
          will be taken.
        </p>

        <p>
          Users must not knowingly submit false, malicious, or abusive reports.
          Misuse of the reporting system may itself result in enforcement
          action.
        </p>

        <hr />

        <h2>10. Account Suspension, Termination, and Deletion</h2>

        <p>
          Custom Roam reserves the right to suspend, restrict, disable, or
          terminate accounts when necessary to:
        </p>

        <ul>
          <li>Enforce these Terms</li>
          <li>Protect users</li>
          <li>Protect platform security</li>
          <li>Prevent abuse</li>
          <li>Investigate misconduct</li>
          <li>Comply with legal obligations</li>
          <li>Protect Custom Roam's rights, reputation, or operations</li>
        </ul>

        <p>
          Account termination may result in loss of access to content,
          profiles, itineraries, and other account information.
        </p>

        <p>
          Users may permanently delete their own Custom Roam account through
          the account settings available within the Services.
        </p>

        <p>
          Account deletion is permanent and cannot be undone. Upon deletion, we
          will delete or anonymize your personal information and remove
          associated user-generated content in accordance with our Privacy
          Policy, except where we are required or permitted by law to retain
          certain information.
        </p>

        <hr />

        <h2>11. Travel Planning Disclaimer</h2>

        <p>
          Custom Roam provides travel-planning tools, recommendations,
          itineraries, and informational content for convenience only.
        </p>

        <p>We do not guarantee the following concerning any destination:</p>

        <ul>
          <li>Accuracy</li>
          <li>Availability</li>
          <li>Operating hours</li>
          <li>Pricing</li>
          <li>Accessibility</li>
          <li>Safety</li>
          <li>Quality</li>
          <li>Suitability</li>
          <li>Continued existence</li>
        </ul>

        <p>
          These limitations also apply to attractions, businesses, events,
          services, recommendations, and other travel-related information.
        </p>

        <p>
          Users are responsible for independently verifying information before
          making travel decisions.
        </p>

        <hr />

        <h2>12. Automated Recommendations Disclaimer</h2>

        <p>
          Custom Roam may use automated systems, algorithms, artificial
          intelligence, machine learning, or similar technologies to generate
          recommendations and itineraries.
        </p>

        <p>
          Such recommendations may be inaccurate, incomplete, outdated,
          unavailable, or unsuitable for individual circumstances.
        </p>

        <p>
          Users should independently evaluate recommendations before relying
          upon them.
        </p>

        <hr />

        <h2>13. Third-Party Services</h2>

        <p>
          Custom Roam may integrate with third-party services, including:
        </p>

        <ul>
          <li>Google Places</li>
          <li>Google Maps</li>
          <li>Apple services</li>
          <li>Google Play services</li>
          <li>Other third-party services</li>
        </ul>

        <p>Custom Roam is not responsible for:</p>

        <ul>
          <li>Third-party content</li>
          <li>The accuracy of third-party information</li>
          <li>The availability of third-party services</li>
          <li>The policies of third-party providers</li>
          <li>Products or services provided by third parties</li>
        </ul>

        <p>Use of third-party services is at your own risk.</p>

        <hr />

        <h2>14. Intellectual Property</h2>

        <p>
          The Services, including software, code, designs, logos, trademarks,
          branding, content, and other materials, are owned by or licensed to
          Custom Roam.
        </p>

        <p>
          Except as expressly permitted, users may not copy, reproduce,
          distribute, modify, reverse engineer, or exploit any part of the
          Services without written permission.
        </p>

        <hr />

        <h2>15. Copyright and Intellectual Property Complaints</h2>

        <p>
          If you believe content on Custom Roam infringes your copyright or
          other intellectual property rights, contact:
        </p>

        <p>
          <a href="mailto:support@customroam.com">
            support@customroam.com
          </a>
        </p>

        <p>
          Please include sufficient information to identify the allegedly
          infringing content and your ownership rights.
        </p>

        <p>
          Custom Roam may restrict or remove content while investigating a
          complaint.
        </p>

        <hr />

        <h2>16. Privacy</h2>

        <p>
          Your use of the Services is also governed by the Custom Roam Privacy
          Policy.
        </p>

        <p>
          By using the Services, you acknowledge the collection, use, storage,
          and disclosure of information as described in the Privacy Policy.
        </p>

        <p>
          <button
            type="button"
            className="policy-inline-link"
            onClick={() => navigate("/privacy-policy")}
          >
            Read the Custom Roam Privacy Policy
          </button>
        </p>

        <hr />

        <h2>17. No Warranty</h2>

        <p>
          The Services are provided on an "AS IS" and "AS AVAILABLE" basis.
        </p>

        <p>
          To the fullest extent permitted by law, Custom Roam disclaims all
          warranties, whether express, implied, statutory, or otherwise.
        </p>

        <p>We do not guarantee:</p>

        <ul>
          <li>Continuous availability</li>
          <li>Error-free operation</li>
          <li>Security</li>
          <li>Accuracy</li>
          <li>Reliability</li>
          <li>Fitness for a particular purpose</li>
        </ul>

        <hr />

        <h2>18. Limitation of Liability</h2>

        <p>
          To the fullest extent permitted by law, Custom Roam shall not be
          liable for any:
        </p>

        <ul>
          <li>Indirect damages</li>
          <li>Incidental damages</li>
          <li>Consequential damages</li>
          <li>Special damages</li>
          <li>Exemplary damages</li>
          <li>Punitive damages</li>
        </ul>

        <p>
          This limitation applies to damages arising out of or related to your
          use of, or inability to use, the Services.
        </p>

        <hr />

        <h2>19. Maximum Liability</h2>

        <p>
          To the maximum extent permitted by law, Custom Roam's total liability
          for any claim arising from or relating to the Services shall not
          exceed the greater of:
        </p>

        <ul>
          <li>CAD $100; or</li>
          <li>
            The amount paid by the user to Custom Roam during the twelve months
            preceding the claim.
          </li>
        </ul>

        <hr />

        <h2>20. Indemnification</h2>

        <p>
          To the extent permitted by applicable law, you agree to defend,
          indemnify, and hold harmless Custom Roam, its owners, affiliates,
          partners, officers, employees, contractors, and agents from claims,
          damages, liabilities, losses, expenses, or costs arising from:
        </p>

        <ul>
          <li>Your use of the Services</li>
          <li>Your content</li>
          <li>Your violation of these Terms</li>
          <li>Your violation of applicable laws</li>
          <li>Your infringement of third-party rights</li>
        </ul>

        <hr />

        <h2>21. Force Majeure</h2>

        <p>
          Custom Roam shall not be liable for delays, interruptions, failures,
          or inability to perform resulting from events beyond its reasonable
          control, including:
        </p>

        <ul>
          <li>Natural disasters</li>
          <li>Internet outages</li>
          <li>Cyberattacks</li>
          <li>Government actions</li>
          <li>Labor disputes</li>
          <li>Infrastructure failures</li>
          <li>Service-provider outages</li>
        </ul>

        <hr />

        <h2>22. Changes to These Terms</h2>

        <p>We may modify these Terms from time to time.</p>

        <p>
          Updated Terms may be posted on our website or mobile applications or
          communicated through email, notifications, or other reasonable means.
        </p>

        <p>
          Continued use of the Services after changes become effective
          constitutes acceptance of the updated Terms.
        </p>

        <hr />

        <h2>23. Governing Law</h2>

        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of the jurisdiction in which Custom Roam is legally established,
          without regard to conflict-of-law principles.
        </p>

        <p>
          Specific jurisdiction and venue provisions may be updated following
          the legal incorporation of the business.
        </p>

        <hr />

        <h2>24. Contact Us</h2>

        <p>
          If you have questions regarding these Terms, contact us at:
        </p>

        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:support@customroam.com">
            support@customroam.com
          </a>
        </p>

        <p>
          <strong>Website:</strong>{" "}
          <a
            href="https://www.customroam.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.customroam.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsPage;